import { ModulusAPIResponse } from '@unx/shared/api/external-api'
import { useCallback } from 'react'
import { getNextURL } from '../utils/getNextURL'

type PayloadObject = Record<string, string | number | boolean | undefined>

export const UNAUTHORIZED_RESPONSE: ModulusAPIResponse<unknown> = {
  message: 'Unauthorized',
  status: 'Error',
  data: null,
}

const getHeaders = () => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  return headers
}

const post = async <T>(url: string, data: PayloadObject = {}) => {
  const response = await fetch(getNextURL() + url, {
    method: 'POST',
    headers: getHeaders(),
    credentials: 'include',
    body: JSON.stringify(data),
  })

  const jsonData = await response.json()

  return jsonData as ModulusAPIResponse<T>
}

const get = async <T>(url: string) => {
  const response = await fetch(getNextURL() + url, {
    method: 'GET',
    credentials: 'include',
    headers: getHeaders(),
  })

  const jsonData = await response.json()

  return jsonData as ModulusAPIResponse<T>
}

export const InternalApi = { post, get }

// TODO: Remove useInternalAPI and use InternalApi directly
/**
 * @deprecated This hook is deprecated and should not be used in new code.
 * Use the `InternalApi` object directly instead.
 */
export const useInternalAPI = () => {
  const postCB = useCallback(post, [])

  const getCB = useCallback(get, [])

  return {
    get: getCB,
    post: postCB,
  }
}
